import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../../Network/API";

export default function SiteSiteDownHistory() {
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [exporting, setExporting] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [applied, setApplied] = useState({ start: "", end: "" });

    const load = (nextPage = 1, dates = applied) => {
        setLoading(true);
        const params = new URLSearchParams({
            site_id: id,
            page: String(nextPage),
        });
        if (dates.start && dates.end) {
            params.set("start_date", dates.start);
            params.set("end_date", dates.end);
        }
        API.get(`/v1/oauth/site_dashboard_down_history?${params.toString()}`)
            .then((response) => {
                const data = response.data?.data || {};
                setRows(data.history || []);
                setPage(data.current_page || 1);
                setLastPage(data.last_page || 1);
                setTotal(data.total_page || 0);
            })
            .catch(() => {
                setRows([]);
                setTotal(0);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (!id) return;
        setApplied({ start: "", end: "" });
        setStartDate("");
        setEndDate("");
        load(1, { start: "", end: "" });
    }, [id]);

    const search = (event) => {
        event.preventDefault();
        if ((startDate && !endDate) || (!startDate && endDate)) {
            alert("Select both From Date and To Date");
            return;
        }
        const dates = { start: startDate, end: endDate };
        setApplied(dates);
        load(1, dates);
    };

    const exportCsv = () => {
        if (!startDate || !endDate) {
            alert("Select From Date and To Date before export");
            return;
        }
        setExporting(true);
        const params = new URLSearchParams({
            site_id: id,
            start_date: startDate,
            end_date: endDate,
        });
        API.get(`/v1/oauth/site_dashboard_down_history/export?${params.toString()}`, { responseType: "blob" })
            .then((response) => {
                const blob = new Blob([response.data], { type: "text/csv" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `${startDate}_${endDate}_site_down_history.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
            })
            .catch(() => alert("Could not export site down history"))
            .finally(() => setExporting(false));
    };

    return (
        <div className="row ms-1 me-1">
            <div className="col-12">
                <div className="card shadow-sm border-0 bg-cc mt-2">
                    <div className="card-header border-bottom card-title bg-white d-flex flex-wrap align-items-center gap-2">
                        <b className="main-card-title mb-0 flex-grow-1">Site Down History</b>
                        <form onSubmit={search}>
                            <div className="input-group input-group-sm">
                                <span className="input-group-text">From Date</span>
                                <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                <span className="input-group-text">To Date</span>
                                <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                <button type="submit" className="btn btn-outline-info">
                                    <i className="fa fa-search me-1"></i>
                                    Search
                                </button>
                                <button type="button" className="btn btn-success" onClick={exportCsv} disabled={exporting}>
                                    <i className="fa-solid fa-file-csv me-1"></i>
                                    {exporting ? "Exporting..." : "Export"}
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="card-body bg-white">
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-center mb-2">
                                <thead>
                                    <tr>
                                        <th rowSpan="2">Site ID</th>
                                        <th rowSpan="2">Tenant</th>
                                        <th colSpan="2">Mains Fail</th>
                                        <th colSpan="2">Dc Low</th>
                                        <th colSpan="2">Site Down</th>
                                        <th rowSpan="2">Battery Backup</th>
                                    </tr>
                                    <tr>
                                        <th>Start</th>
                                        <th>End</th>
                                        <th>Start</th>
                                        <th>End</th>
                                        <th>Start</th>
                                        <th>End</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading && (
                                        <tr><td colSpan="9">Loading...</td></tr>
                                    )}
                                    {!loading && rows.length === 0 && (
                                        <tr><td colSpan="9">No site down history found</td></tr>
                                    )}
                                    {!loading && rows.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.site_id}</td>
                                            <td>{row.tenant_name}</td>
                                            <td>{row.mf_start}</td>
                                            <td>{row.mf_end}</td>
                                            <td>{row.dclow_start}</td>
                                            <td>{row.dclow_end}</td>
                                            <td>{row.site_down_start}</td>
                                            <td>{row.site_down_end}</td>
                                            <td>{row.battery_backup}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="fs-12">Page {page} of {lastPage}, {total} record(s)</span>
                            <div className="btn-group btn-group-sm">
                                <button type="button" className="btn btn-outline-secondary" disabled={loading || page <= 1} onClick={() => load(page - 1)}>
                                    Previous
                                </button>
                                <button type="button" className="btn btn-outline-secondary" disabled={loading || page >= lastPage} onClick={() => load(page + 1)}>
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
